import React from 'react';

interface IconProps {
    fillColor?: string;
    height?: number;
    width?: number;
}

const MMSOffline: React.FC<IconProps> = ({ fillColor = '#A5A5A5', height = 24, width = 24 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.2001 14.64C15.5448 14.64 15.8241 14.9194 15.8241 15.264V17.76C15.8241 18.1046 15.5448 18.384 15.2001 18.384C14.8555 18.384 14.5761 18.1046 14.5761 17.76V15.264C14.5761 14.9194 14.8555 14.64 15.2001 14.64Z"
                fill={fillColor}
            />
            <path
                d="M15.2001 19.632C14.8555 19.632 14.5761 19.9114 14.5761 20.256C14.5761 20.6006 14.8555 20.88 15.2001 20.88H15.2064C15.551 20.88 15.8304 20.6006 15.8304 20.256C15.8304 19.9114 15.551 19.632 15.2064 19.632H15.2001Z"
                fill={fillColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.8001 0.63C14.4267 0.21 13.9734 0 13.4401 0H4.48006C3.94672 0 3.49339 0.21 3.12006 0.63C2.74673 1.05 2.56006 1.56 2.56006 2.16V20.88C2.56006 21.48 2.74673 21.99 3.12006 22.41C3.49339 22.83 3.94672 23.04 4.48006 23.04H11.8731C12.8361 23.6481 13.977 24 15.2001 24C18.6464 24 21.4401 21.2063 21.4401 17.76C21.4401 14.3404 18.6895 11.5633 15.2801 11.5205C15.3067 11.5202 15.3334 11.52 15.3601 11.52V2.16C15.3601 1.56 15.1734 1.05 14.8001 0.63ZM14.7201 11.5382V2.38023C14.7201 1.89681 14.5521 1.48591 14.2161 1.14752C13.8801 0.809131 13.4721 0.639936 12.9921 0.639936H4.92807C4.44807 0.639936 4.04007 0.809131 3.70407 1.14752C3.36807 1.48591 3.20007 1.89681 3.20007 2.38023V18.727C3.20007 19.2104 3.36807 19.6213 3.70407 19.9597C4.04007 20.2981 4.44807 20.4673 4.92807 20.4673H9.57642C9.18148 19.6484 8.96014 18.73 8.96014 17.76C8.96014 14.4753 11.4981 11.7833 14.7201 11.5382ZM9.68595 21.7315C9.68595 22.1639 9.33542 22.5145 8.90302 22.5145C8.47061 22.5145 8.12008 22.1639 8.12008 21.7315C8.12008 21.2991 8.47061 20.9486 8.90302 20.9486C9.33542 20.9486 9.68595 21.2991 9.68595 21.7315ZM15.2001 22.8114C17.99 22.8114 20.2516 20.5498 20.2516 17.76C20.2516 14.9702 17.99 12.7086 15.2001 12.7086C12.4103 12.7086 10.1487 14.9702 10.1487 17.76C10.1487 20.5498 12.4103 22.8114 15.2001 22.8114Z"
                fill={fillColor}
            />
        </svg>
    );
};

export default MMSOffline;
